// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"143":"abddcbeb","815":"e3bdb804"}[chunkId] + ".chunk.css";
};